import React from 'react'
import { 
    Form, FormCell, CellBody, TextArea, Input, Button, Flex, FlexItem, Toast, Toptips,
    Dialog
} from 'react-weui'
import { browserHistory } from 'react-router'
import axios from 'axios'
import { storage, isLZWKAPP } from '../../utils'
import closeImg from '../../images/close-grey.png'
import { Page } from '../../components'
import { WKVisible } from '../../components/wk'
import Header from '../../components/liveroomLecturer/Header'
import headerImg1 from '../../images/feedback/header-1.png'
import '../../css/page/FeedbackPage.css'


class FeedbackPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            desc: '',
            phone: '',
            images: [],
            isPending: false,
            covers: [],
            files: [],
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            alertDialog: {
                isShow: false,
                text: '',
            },
        }
    }
    componentDidMount () {
        document.title = '意见反馈'
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    onChangeFile (e) {
        const file = e.target.files[0]
        if (!file) return
        const _this = this
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function(e) {
            _this.setState({ covers: _this.state.covers.concat(this.result), files: _this.state.files.concat(file) })
        }
    }
    _onChangeFile (e) {
        const file = e.target.files[0]
        if (!file) {
            return
        }
        this.setState({ isPending: true })
        const formData = new FormData()
        formData.append('description', file)
        formData.append('target_id', 0)
        formData.append('storage_type', 'lecture')
        axios.post('/api/upload_img', formData, {
            timeout: 20000
        })
            .then(res => {
                if (this.state.images.indexOf(res.data.data.img) > -1) {
                    return this.showTip('重复上传照片了')
                }
                this.setState({ 
                    isPending: false,
                    images: this.state.images.concat(res.data.data.img)
                })
            })
            .catch(err => {
                if (err.message.indexOf('timeout') > -1) {
                    this.showTip('上传图片超时')
                } else {
                    this.showTip('上传图片错误')
                }
            })
            .then(res => {
                this.setState({ isPending: false })
            })
    }
    onClickClose (e, i) {
        this.$fileInput.value = ''
        this.setState({
            covers: this.state.covers.filter((item, _i) => _i !== i),
            files: this.state.files.filter((item, _i) => _i !== i),
        })
        // if (this.state.covers.indexOf(image) > -1) {
        //     this.setState({ covers: this.state.covers.filter(item => item !== image) })
        // } else {
        //     this.setState({ covers: this.state.covers.concat(image) })
        // }
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    onSubmit () {
        const formData = new FormData()
        const desc = this.state.desc.trim()
        const phone = this.state.phone.trim()
        if (!desc) {
            return this.showTip('请填写意见和建议')
        }
        if (!phone) {
            return this.showTip('请填写电话号码')
        }
        if (desc.length > 200) {
            return this.showTip('意见和建议200字以内')
        }
        this.setState({ isPending: true })
        formData.append('reason', desc)
        formData.append('mobile', phone)
        formData.append('category', 'product_feedback')
        this.state.files.forEach(item => {
            formData.append('pictures[]', item)
        })
        axios.post('/api/complain/', formData)
            .then(res => {
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.showAlert('提交成功！')
            })
            .catch(err => {
                this.showTip('系统繁忙，请稍后再试')
            })
            .then(res => {
                this.setState({ isPending: false })
            })
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    onClickSuccessOk () {
        this.setState({ alertDialog: { isShow: false } })
        if (isLZWKAPP()) {
            if (window.systemType === 'android') {
                WKApp.onBack()
            }
            if (window.systemType === 'ios') {
                window.webkit.messageHandlers.WKApp.postMessage({
                    function: "onBack",
                })
            }
        } else {
            browserHistory.go(-1)
        }
    }
    render() {
        return (
            <Page>
                <div className="wk-inner-page feedback-page">
                    <div className="header">
                        <img src={headerImg1} />
                    </div>
                    <Header title='意见和建议' />
                    <Form className='margin-bottom'>
                        <FormCell>
                            <CellBody>
                                <TextArea 
                                    value={this.state.desc} 
                                    placeholder="请描述你遇到的问题或功能建议" 
                                    rows="4" 
                                    showCounter={true}
                                    onChange={e => this.bindValue(e, 'desc')}
                                    maxlength="200"
                                >
                                </TextArea>
                            </CellBody>
                        </FormCell>
                    </Form>
                    <Header title='图片（选填，请提供相关图片，最多4张）' />
                    <div className='upload-wrap'>
                        {
                            this.state.covers.map((item, i) => (
                                <div className="upload-item" key={i}>
                                    <img className='image' src={item} />
                                    <div className="close" onClick={e => this.onClickClose(e, i)}>
                                        <img src={closeImg} />
                                    </div>
                                </div>
                            ))
                        }
                        <WKVisible show={this.state.covers.length < 4}>
                            <div className="upload-item">
                                <div className="weui-uploader__input-box"></div>
                                <input type="file" ref={r => this.$fileInput = r} onChange={e => this.onChangeFile(e)} />
                            </div>
                        </WKVisible>
                    </div>
                    <Header title='联系电话' />
                    <Form className='margin-bottom'>
                        <FormCell>
                            <CellBody>
                                <Input 
                                    type="tel" 
                                    placeholder="必填，便于我们与你联系" 
                                    onChange={e => this.bindValue(e, 'phone')}
                                />
                            </CellBody>
                        </FormCell>
                    </Form>
                    <div className="wk-btn-90">
                        <Button onClick={e => this.onSubmit()}>提交</Button>
                    </div>
                </div>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickSuccessOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
            </Page>
        )
    }
}


export default FeedbackPage


// WEBPACK FOOTER //
// ./src/pages/feedback/FeedbackPage.js